import { Box } from '@mui/material';
import React from 'react';

import { CenterCellContainer } from './CenterCellContainer';

export const CellUrgency = ({ urgency }: { urgency: string }) => {
  const color = urgency === 'Urgent' ? 'error' : 'success';
  return (
    <CenterCellContainer>
      <Box sx={{ width: 16, height: 16, borderRadius: '50%', backgroundColor: (theme) => theme.palette[color].main }} />
    </CenterCellContainer>
  );
};
